import React from "react";
import { toast } from "sonner";
import { QrCode, X } from "lucide-react";
import { Table, Td, fmtDate } from "../AdminUi";
import { inr } from "../pricing/PricingUi";
import { api, errMsg } from "../../../lib/api";
import { linkStatus } from "./LinkResult";

export const PaymentLinksTable = ({ rows, onShow, onChange }) => {
  const cancel = async (l) => {
    try { await api.adminCancelPaymentLink(l.id); toast.success("Link cancelled"); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Table head={["Merchant", "Credits", "Amount", "Status", "Created", ""]} testid="payment-links-table" empty={rows.length === 0 && "No payment links yet."}>
      {rows.map((l) => {
        const [label, cls] = linkStatus(l.status);
        return (
          <tr key={l.id} data-testid={`payment-link-row-${l.id}`} className="hover:bg-slate-50">
            <Td><div className="text-slate-800">{l.user_name || l.user_email}</div><div className="text-xs text-slate-500">{l.user_email}</div></Td>
            <Td className="font-mono">{l.credits}</Td>
            <Td className="font-mono">{inr(l.amount_paise / 100)}</Td>
            <Td><span className={`px-2 py-0.5 rounded-full border text-[11px] whitespace-nowrap ${cls}`} data-testid={`payment-link-row-status-${l.id}`}>{label}</span></Td>
            <Td className="text-xs text-slate-500 whitespace-nowrap">{fmtDate(l.created_at)}</Td>
            <Td className="text-right whitespace-nowrap">
              <button onClick={() => onShow(l)} data-testid={`payment-link-show-${l.id}`} className="p-1.5 text-slate-500 hover:text-sky-600" aria-label="Show QR"><QrCode size={15} /></button>
              {l.status === "created" && <button onClick={() => cancel(l)} data-testid={`payment-link-cancel-${l.id}`} className="p-1.5 text-slate-400 hover:text-rose-600" aria-label="Cancel link"><X size={15} /></button>}
            </Td>
          </tr>
        );
      })}
    </Table>
  );
};

export default PaymentLinksTable;
